export enum HttpMethod{
  POST='Post',
  PUT='Put',
  DELETE='Delete',
  GET='Get'
}
